<template>
  <svg
    id="Thumbup--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height="24"
    width="24"
  >
    <desc>Thumbup Streamline Icon: https://streamlinehq.com</desc>
    <path
      d="M23.34 8.991a2.77 2.77 0 0 0 -2.117 -0.98H14.19l0.794 -4.53A2 2 0 0 0 13.9 1.444l-0.447 -0.223a2 2 0 0 0 -1.553 -0.1 1.963 1.963 0 0 0 -1.126 0.991L5.405 12H1a1 1 0 0 0 -1 1v8.984a1 1 0 0 0 1 1L17 23a5.944 5.944 0 0 0 5.874 -4.987l1.087 -6.769a2.769 2.769 0 0 0 -0.621 -2.253z"
      fill="currentColor"
      stroke-width="1"
    ></path>
  </svg>
</template>
